import { render, staticRenderFns } from "./PgaOfferEvaluationHeaderCustomerOrderCreate.vue?vue&type=template&id=7f68ea4a&"
import script from "./PgaOfferEvaluationHeaderCustomerOrderCreate.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationHeaderCustomerOrderCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f68ea4a')) {
      api.createRecord('7f68ea4a', component.options)
    } else {
      api.reload('7f68ea4a', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationHeaderCustomerOrderCreate.vue?vue&type=template&id=7f68ea4a&", function () {
      api.rerender('7f68ea4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/PgaOfferEvaluationHeaderCustomerOrderCreate.vue"
export default component.exports